__turbopack_context__.v({
  "amount": "top-winners-module-sass-module__f6gNqW__amount",
  "container": "top-winners-module-sass-module__f6gNqW__container",
  "content": "top-winners-module-sass-module__f6gNqW__content",
  "crown": "top-winners-module-sass-module__f6gNqW__crown",
  "fadeIn": "top-winners-module-sass-module__f6gNqW__fadeIn",
  "headerTitle": "top-winners-module-sass-module__f6gNqW__headerTitle",
  "name": "top-winners-module-sass-module__f6gNqW__name",
  "payout": "top-winners-module-sass-module__f6gNqW__payout",
  "subHeader": "top-winners-module-sass-module__f6gNqW__subHeader",
  "topWinner": "top-winners-module-sass-module__f6gNqW__topWinner",
  "topWinnerImg": "top-winners-module-sass-module__f6gNqW__topWinnerImg",
  "topWinnerImgCasino": "top-winners-module-sass-module__f6gNqW__topWinnerImgCasino",
  "topWinnersCarousel": "top-winners-module-sass-module__f6gNqW__topWinnersCarousel",
  "topWinnersList": "top-winners-module-sass-module__f6gNqW__topWinnersList",
});
